function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.95 1.288c0-.372.129-.62.386-.867a1.277 1.277 0 011.8 0L9.95 6.98 16.764.421a1.277 1.277 0 011.8 0c.515.495.515 1.238 0 1.733L10.85 9.579a1.277 1.277 0 01-1.8 0L1.336 2.154C1.079 1.906.95 1.659.95 1.288z",
  fill: "#F58220",
  fillRule: "nonzero"
});

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgArrowDown;